import { render, staticRenderFns } from "./HumanResources.vue?vue&type=template&id=3aa38149&scoped=true&"
import script from "./HumanResources.vue?vue&type=script&lang=js&"
export * from "./HumanResources.vue?vue&type=script&lang=js&"
import style0 from "./HumanResources.vue?vue&type=style&index=0&id=3aa38149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa38149",
  null
  
)

export default component.exports